export default "__VITE_PUBLIC_ASSET__3c199535__"